module.exports = __webpack_public_path__ + "img/earn-count-btn-2.8d594db1.png";